import { render, staticRenderFns } from "./TypeTextPanel.vue?vue&type=template&id=4cfc081b&scoped=true&"
import script from "./TypeTextPanel.vue?vue&type=script&lang=js&"
export * from "./TypeTextPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfc081b",
  null
  
)

export default component.exports